// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"125":"component---src-pages-404-js","223":"commons","293":"component---src-pages-index-js","771":"component---src-pages-page-2-js"}[chunkId] + "-" + {"125":"3dccdc32ceb84f89c108","223":"0c30767c53c91cb4dd52","293":"a84469b404698704327e","771":"43dce3d36dcf1d101be9"}[chunkId] + ".js";
};